import React from "react";
import { useModal } from "../ModalRoot/ModalRoot";
import styles from "./ModalClose.module.scss";
import { ReactSVG } from "react-svg";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { useAppContext } from "@/context/AppContext";

interface ModalCloseProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  className?: string;
}

export const ModalClose: React.FC<ModalCloseProps> = ({
  children,
  className = "",
  ...rest
}) => {
  const { setOpen } = useModal();
  const { getIcon, getLabel } = useGlobalContext();
  const { setFormModalType } = useAppContext();

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(false);
    setFormModalType("text");
    rest.onClick?.(e);
  };

  return (
    <button
      type="button"
      onClick={handleClose}
      className={`modal-close-btn ${styles["modal-close-btn"]} ${className}`.trim()}
      {...rest}
      aria-label={getLabel("modal_close")}
    >
      {children ?? (
        <ReactSVG
          src={getIcon("close")}
          wrapper={"svg"}
          width={32}
          height={32}
          aria-hidden
        />
      )}
    </button>
  );
};
